import { defineComponent, ref, computed, onMounted, onBeforeUnmount } from '@vue/composition-api';
import { debounce } from '../../node_modules/@superbet-group/web.lib.utilities/dist/index.esm.js';
import __vue_component__ from './SdsCarouselDot.vue.js';

var script = defineComponent({
    name: 'Carousel',
    emits: [
        'carouselSlideChange',
    ],
    props: {
        hideNavigation: {
            type: Boolean,
            default: false,
        },
        screenSize: {
            type: String,
            default: 'dXs',
        },
    },
    setup: function (_props, _a) {
        var emit = _a.emit;
        var carouselSlidesRef = ref();
        var numberOfSlides = ref();
        var activeSlideIndex = ref(0);
        var carouselWidth = ref(0);
        var slideWidth = computed(function () {
            if (carouselSlidesRef.value && numberOfSlides.value) {
                return carouselWidth.value / numberOfSlides.value;
            }
            else {
                return 0;
            }
        });
        var debouncedUpdateSlideIndex = debounce(function () {
            activeSlideIndex.value = Math.round(carouselSlidesRef.value.scrollLeft / slideWidth.value);
            emit('carouselSlideChange', activeSlideIndex.value);
        }, 50);
        var updateSlideIndex = function () {
            debouncedUpdateSlideIndex();
        };
        function scrollToSlide(index) {
            var _a;
            activeSlideIndex.value = index;
            (_a = carouselSlidesRef.value) === null || _a === void 0 ? void 0 : _a.scrollTo({ left: slideWidth.value * index });
        }
        function updateNumberOfSlides() {
            numberOfSlides.value = carouselSlidesRef.value.children.length;
        }
        function updateCarouselWidth() {
            carouselWidth.value = carouselSlidesRef.value.scrollWidth;
        }
        var mutationObserver;
        var resizeObserver;
        onMounted(function () {
            carouselSlidesRef.value.addEventListener('scroll', updateSlideIndex);
            updateNumberOfSlides();
            mutationObserver = new MutationObserver(function () {
                updateNumberOfSlides();
                updateCarouselWidth();
            });
            mutationObserver.observe(carouselSlidesRef.value.getRootNode(), {
                childList: true,
                subtree: true,
            });
            resizeObserver = new ResizeObserver(updateCarouselWidth);
            resizeObserver.observe(carouselSlidesRef.value);
        });
        onBeforeUnmount(function () {
            carouselSlidesRef.value.removeEventListener('scroll', updateSlideIndex);
            mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
        });
        return {
            carouselSlidesRef: carouselSlidesRef,
            numberOfSlides: numberOfSlides,
            activeSlideIndex: activeSlideIndex,
            scrollToSlide: scrollToSlide,
        };
    },
    components: {
        SdsCarouselDot: __vue_component__,
    },
});

export default script;
